import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseApi } from '../../../../dtos/response-api';
import { Observable } from 'rxjs';
import { Orgao } from '../../../../dtos/sai/core/orgao';

@Injectable({
  providedIn: 'root'
})
export class OrgaoService {

  private baseUrl = `${environment.apiUrl}/sai/core/orgao`;

  constructor(private http: HttpClient) { }

  getOrgaosAtivos(): Observable<ResponseApi<Orgao[]>> {
    return this.http.get<ResponseApi<Orgao[]>>(`${this.baseUrl}`);
  }
  getOrgaosFilhos(bitAtivo = true): Observable<ResponseApi<Orgao[]>> {
    return this.http.get<ResponseApi<Orgao[]>>(`${this.baseUrl}/filhos`, { params: { bitAtivo } });
  }

  getOrgaoByMunicipio(codMunicipioMun: Number): Observable<ResponseApi<Orgao[]>> {
    return this.http.get<ResponseApi<Orgao[]>>(`${this.baseUrl}/${codMunicipioMun}`);
  }
}

